import React from 'react';
import { FiX, FiCheck, FiAlertCircle, FiDownload } from 'react-icons/fi';

const BulkInvoiceDownloadModal = ({
  isOpen,
  onClose,
  total,
  completed,
  failed,
  isDone,
  isDownloading,
}) => {
  if (!isOpen) return null;

  const progress = total > 0 ? Math.round(((completed + failed.length) / total) * 100) : 0;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-xl w-full max-w-md">
        <div className="p-6 border-b border-gray-200">
          <div className="flex justify-between items-center">
            <div>
              <h2 className="text-xl font-semibold text-gray-800">Downloading Invoices</h2>
              <p className="text-sm text-gray-600 mt-1">
                {isDone ? 'Finished processing selected invoices' : 'Generating invoices, please wait...'}
              </p>
            </div>
            {isDone && (
              <button onClick={onClose} className="text-gray-500 hover:text-gray-700 p-2">
                <FiX className="w-6 h-6" />
              </button>
            )}
          </div>
        </div>

        <div className="p-6">
          <div className="mb-6">
            <div className="flex justify-between items-center mb-2">
              <span className="text-sm font-medium text-gray-700">
                {completed + failed.length} of {total} invoices
              </span>
              <span className="text-sm text-gray-500">{progress}%</span>
            </div>
            <div className="w-full bg-gray-200 rounded-full h-2">
              <div
                className="bg-blue-600 h-2 rounded-full transition-all duration-300"
                style={{ width: `${progress}%` }}
              />
            </div>
          </div>

          {failed.length > 0 && (
            <div className="mb-6 p-4 bg-red-50 border border-red-200 rounded-lg">
              <div className="flex items-center space-x-2 mb-2">
                <FiAlertCircle className="w-5 h-5 text-red-600 shrink-0" />
                <span className="text-sm text-red-800 font-medium">
                  {failed.length} invoice{failed.length !== 1 ? 's' : ''} failed to generate
                </span>
              </div>
              <ul className="text-xs text-red-700 list-disc list-inside space-y-0.5">
                {failed.map((f) => (
                  <li key={f.id}>{f.label}</li>
                ))}
              </ul>
            </div>
          )}

          {isDone && (
            <div className="text-center">
              <div className="mb-4">
                {failed.length === 0 ? (
                  <FiCheck className="w-12 h-12 text-green-600 mx-auto mb-2" />
                ) : (
                  <FiAlertCircle className="w-12 h-12 text-amber-500 mx-auto mb-2" />
                )}
                <h3 className="text-lg font-semibold text-gray-800 mb-1">
                  {completed > 0
                    ? `${completed} invoice${completed !== 1 ? 's' : ''} downloaded`
                    : 'No invoices downloaded'}
                </h3>
                {completed > 0 && (
                  <p className="text-sm text-gray-600">Your invoices have been saved as a .zip file</p>
                )}
              </div>

              <button
                onClick={onClose}
                className="w-full inline-flex items-center justify-center px-4 py-2 text-sm font-medium rounded-lg text-gray-700 bg-gray-100 border border-gray-300 hover:bg-gray-200"
              >
                Close
              </button>
            </div>
          )}

          {!isDone && (
            <div className="flex items-center justify-center gap-2 text-sm text-gray-500">
              <FiDownload className="w-4 h-4 animate-pulse" />
              {isDownloading ? 'Preparing zip file...' : 'Generating PDFs...'}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default BulkInvoiceDownloadModal;
